import PanelLarge from './PanelLarge.jsx';

export default PanelLarge;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/FilterGroupCollection/Panels/PanelLarge/index.js